export const TRANSLATIONS_FR_GENERATION = {
  "generate.title": "Generer un document",
  "generate.subtitle": "Resume executif a partir des sources selectionnees",
  "generate.action": "Generer",
  "generate.generating": "Generation...",
  "generate.sources.title": "Sources",
  "generate.sources.clear": "Effacer la selection",
  "generate.sources.loading": "Chargement des documents...",
  "generate.language": "Langue",
  "generate.expertRole": "Expert",
  "generate.expertRole.general": "General",
  "generate.message.label": "Message pour le résumé (optionnel)",
  "generate.message.placeholder": "Ex. : concentrez-vous sur les risques et les prochaines étapes…",
  "generate.message.counter": "{count}/{max}",
  "generate.validation.selectSource": "Selectionnez au moins une source.",
  "generate.toast.success": "Brouillon genere.",
  "generate.toast.enqueued": "Génération en file d'attente. Elle sera prête dans quelques minutes ; nous vous préviendrons.",
  "generate.errors.documents": "Impossible de charger les documents.",
  "generate.errors.forbidden": "Votre plan ne permet pas la generation ou le quota est atteint.",
  "generate.errors.insufficientEvidence": "Les preuves selectionnees sont insuffisantes.",
  "generate.errors.generic": "Impossible de generer le document.",
  "generate.errors.download": "Impossible de telecharger le PDF.",
  "generate.picker.title": "Quels documents voulez-vous sélectionner pour générer votre résumé ?",
  "generate.picker.searchPlaceholder": "Rechercher des documents…",
  "generate.picker.empty": "Aucun document trouvé.",
  "generate.picker.selected": "sélectionnés",
  "generate.picker.confirm": "Terminé",
  "generate.picker.open": "Sélectionner des documents",
  "generate.sources.empty": "Aucun document sélectionné. Utilisez « Sélectionner des documents » pour les choisir.",
  "generate.warnings.sourcesUnavailable": "Certaines sources ne sont plus disponibles et ont été retirées. Consultez-les à nouveau si nécessaire.",
  "generate.preview.title": "Apercu",
  "generate.preview.empty": "Selectionnez des sources et generez le brouillon.",
  "generate.download": "Telecharger le PDF",
  "generate.downloading": "Telechargement...",
  "generate.mySummaries": "Documents Générés",
  "generate.history.title": "Documents Générés",
  "generate.history.subtitle": "Historique des résumés exécutifs générés",
  "generate.export.docx": "Télécharger le DOCX",
  "generate.export.draftWatermark": "Le téléchargement inclura le filigrane BROUILLON (document non approuvé)",
  "generate.history.notify.ready": "Votre résumé exécutif est prêt.",
  "generate.history.notify.failed": "Le résumé n'a pas pu être généré.",
  "generate.history.pagination.label": "Pagination",
  "generate.history.pagination.prev": "Précédent",
  "generate.history.pagination.next": "Suivant",
  "generate.history.unnamedDocument": "Document",
  "generate.history.enqueuedBanner": "Votre résumé est en cours de génération en arrière-plan. Nous vous préviendrons dès qu'il sera prêt ; vous pouvez continuer à travailler.",
  "generate.history.dismiss": "Fermer",
  "generate.history.new": "Nouveau résumé",
  "generate.history.col.files": "Fichiers",
  "generate.history.col.created": "Créé",
  "generate.history.col.status": "Statut",
  "generate.history.col.expert": "Expert",
  "generate.history.expert.general": "Général",
  "generate.history.col.actions": "Actions",
  "generate.history.status.downloaded": "Téléchargé",
  "generate.history.status.pending": "En attente",
  "generate.history.status.processing": "En cours",
  "generate.history.status.completed": "Terminé",
  "generate.history.status.failed": "Échec",
  "generate.history.action.download": "Télécharger le PDF",
  "generate.history.action.regenerate": "Régénérer",
  "generate.history.empty": "Vous n'avez encore généré aucun résumé.",
  "generate.history.emptyCta": "Générer mon premier résumé",
  "generate.history.loading": "Chargement des résumés...",
  "generate.history.error": "Impossible de charger les résumés.",
  "generate.history.retry": "Réessayer",
  "generate.history.moreFiles": "+{count}",
  "generate.history.col.message": "Message",
  "generate.history.noMessage": "—",
  "generate.lifecycle.tabs.label": "Filtrer par statut",
  "generate.lifecycle.tab.all": "Tous",
  "generate.lifecycle.tab.draft": "Brouillons",
  "generate.lifecycle.tab.in_review": "En révision",
  "generate.lifecycle.tab.approved": "Approuvés",
  "generate.lifecycle.tab.rejected": "Rejetés",
  "generate.lifecycle.tab.archived": "Archivés",
  "generate.lifecycle.status.draft": "Brouillon",
  "generate.lifecycle.status.in_review": "En révision",
  "generate.lifecycle.status.approved": "Approuvé",
  "generate.lifecycle.status.rejected": "Rejeté",
  "generate.lifecycle.status.archived": "Archivé",
  "generate.lifecycle.col.version": "Version",
  "generate.lifecycle.action.submit": "Envoyer en révision",
  "generate.lifecycle.action.approve": "Approuver",
  "generate.lifecycle.action.reject": "Rejeter",
  "generate.lifecycle.action.archive": "Archiver",
  "generate.lifecycle.action.timeline": "Voir l'historique des changements",
  "generate.lifecycle.action.revise": "Corriger et renvoyer",
  "generate.lifecycle.action.unarchive": "Restaurer",
  "generate.lifecycle.confirm.title": "Confirmer l'action",
  "generate.lifecycle.confirm.submit": "Envoyer ce résumé en révision ?",
  "generate.lifecycle.confirm.approve": "Approuver ce résumé ? Il sera marqué comme contenu révisé.",
  "generate.lifecycle.confirm.archive": "Archiver ce résumé ? Il ne sera plus actif.",
  "generate.lifecycle.confirm.cancel": "Annuler",
  "generate.lifecycle.confirm.accept": "Confirmer",
  "generate.lifecycle.reject.title": "Rejeter le résumé",
  "generate.lifecycle.reject.reasonLabel": "Motif du rejet (obligatoire)",
  "generate.lifecycle.reject.placeholder": "Expliquez pourquoi ce résumé est rejeté...",
  "generate.lifecycle.reject.confirm": "Rejeter",
  "generate.lifecycle.confirm.revise": "Remettre ce résumé en brouillon pour le corriger ? Vous pourrez le renvoyer en révision.",
  "generate.lifecycle.confirm.unarchive": "Restaurer ce résumé archivé ? Il redeviendra un brouillon.",
  "generate.lifecycle.toast.submitted": "Résumé envoyé en révision.",
  "generate.lifecycle.toast.approved": "Résumé approuvé.",
  "generate.lifecycle.toast.rejected": "Résumé rejeté.",
  "generate.lifecycle.toast.archived": "Résumé archivé.",
  "generate.lifecycle.toast.revised": "Résumé remis en brouillon.",
  "generate.lifecycle.toast.unarchived": "Résumé restauré en brouillon.",
  "generate.lifecycle.toast.error": "L'action n'a pas pu être effectuée. Veuillez réessayer.",
  "generate.detail.view": "Voir le détail",
  "generate.detail.title": "Détail du résumé",
  "generate.detail.close": "Fermer",
  "generate.detail.empty": "Ce résumé n'a aucun contenu à afficher.",
  "generate.lifecycle.timeline.title": "Historique des changements de statut",
  "generate.lifecycle.timeline.empty": "Aucune transition enregistrée.",
  "generate.lifecycle.timeline.error": "Impossible de charger l'historique des changements.",
  "generate.lifecycle.timeline.close": "Fermer",
  "generate.lifecycle.generatedByAi": "Contenu généré par IA : vérifiez-le avant de l'utiliser comme document officiel.",
  "generate.lifecycle.draftBadge": "BROUILLON — non approuvé",
};
